import { auth } from '@/lib'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuth } from '@/lib'
import { verifyOAuthCallback } from '@/lib/utils/auth-error-handler'

export const Route = createFileRoute('/_auth/login-success')({
  component: RouteComponent,
  beforeLoad: async ({ search }) => {
    // Use enhanced OAuth verification with proper error handling
    const result = await verifyOAuthCallback(
      () => auth.getSession(),
      (search as any)?.redirect
    );

    if (!result.session) {
      throw redirect({
        to: result.redirectTo || '/login',
        search: {
          redirect: (search as any)?.redirect,
        },
      });
    }

    // Persist token early so TRPC HTTP/WS use it immediately on the next page
    try {
      const token = result.session?.data?.session?.token ?? result.session?.data?.token;
      if (token) {
        sessionStorage.setItem('TOKEN', token);
      }
    } catch (error) {
      console.warn('login-success: failed to persist token', error);
    }

    throw redirect({
      to: result.redirectTo || '/dashboard',
      search: {
        // Clear any error parameters on successful redirect
        error: undefined,
      },
    });
  },
})

function RouteComponent() {
  const { user } = useAuth()
  console.log("🚀 ~ user:", user)
  return <div>Hello "/_auth/login-success"!

    <div>
      {JSON.stringify(user, null, 2)}
    </div>
  </div>
}

